export const userTaskJsonMock = {
  id: '1'
}



// WEBPACK FOOTER //
// ./src/app/shared/tests/user-task.json.mock.ts